import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Option } from "react-select/lib/filters";
import useGetLevelOptions from "@modules/shared/selectors/hooks/useGetLevelOptions";
import AdvanceSelector from "../advance-selector";

interface AdvancedLevelSelectorProps {
  onChange?: (option: Option) => void;
  scenario: string;
  levelOption?: Option;
}

const AdvancedLevelSelector = ({ scenario, onChange, levelOption }: AdvancedLevelSelectorProps) => {
  const [value, setValue] = useState(levelOption);

  const { loadOptions } = useGetLevelOptions({
    scenario,
  });

  const { t } = useTranslation();

  return (
    <AdvanceSelector
      isPaginated
      dimension={t("advanced-search.instructor.forms.select-wrapper.level.label")}
      selectPlaceholder={t("advanced-search.instructor.forms.select-wrapper.level.placeholder")}
      loadOptions={loadOptions}
      value={value}
      onChange={option => {
        setValue(option);
        onChange?.(option);
      }}
      notShowLabel
    />
  );
};

export default AdvancedLevelSelector;
